import { HttpMethod, PagingQuery } from "~/extensions/api";
export class RsyncCommand extends PagingQuery {
    constructor(model) {
        super(HttpMethod.Post, "resync");
        this.syncId = model.syncId ?? null;
        this.targetOperation = model.targetOperation ?? null;
        this.identifyCode = model.identifyCode;
        this.userCd = model.userCd ?? null;
        this.buknCd = model.buknCd ?? null;
        this.nyukyokeiyakuNo = model.nyukyokeiyakuNo ?? null;
    }
    syncId = null;
    targetOperation = null;
    identifyCode = "";
    userCd = null;
    buknCd = null;
    nyukyokeiyakuNo = null;
}
